module.exports = __webpack_public_path__ + "img/Humanisme_Tanker_i_tida1.ab1cccb0.jpg";